import { RouteRecordRaw } from 'vue-router';
import { ApprovalDocumentPage, approvalItemGuard } from '@/pages/approval';

export const routeName = 'Aprovacao';

export const route: RouteRecordRaw = {
  // O segmento `registro` separa as duas naturezas. Sem ele, `/aprovacao/61` seria ambiguo: 61
  // pode ser uma revisao de documento E uma matriz, porque as duas tabelas tem sequencia propria.
  // O segmento e opcional de proposito, para os links antigos continuarem abrindo o documento: uma
  // URL sem ele vale como natureza documento, que e o que ela sempre significou.
  path: 'aprovacao/:nature(registro)?/:id',
  name: routeName,
  component: ApprovalDocumentPage,
  beforeEnter: approvalItemGuard,
  meta: {
    requiresAuth: true,
    remountOnParamsChange: true,
    breadcrumb: 'Etapa de Análise Crítica e Aprovação',
    dynamicBreadcrumb: true,
    permissions: [
      { action: 'manageApproval', subject: 'Homologation' },
      { action: 'manageVerification', subject: 'Homologation' },
    ],
    matchMode: 'any',
  },
};
